import {epos2Axios} from "@/interceptors/axios";

class PiecingUpService {
    async getSlotForTicket(serviceTicketId) {
        try {
            serviceTicketId = serviceTicketId.replace(/^0+/, '');

            const response = await epos2Axios.get('/api/servicetickets/'
                + serviceTicketId + "/slot");
            console.log(response.status);

            return {
                status: response.data.status,
                slot: response.data.data.slot || null,
                serviceTicket: response.data.data.service_ticket || null,
                message: response.data.message,
            };
        } catch (error) {
            console.error(`Error: ${error.response.status}`);

            if (error.response.status === 404) {
                return {
                    status: error.response.status,
                    slot: null,
                    message: 'The ticket was not found',
                };
            }
            return {
                status: error.response.status,
                slot: null,
                message: 'An error occurred while fetching the slot for the ticket',
            };
        }
    }

    async confirmSlotForTicket(slotBarcode, ticketId) {
        try {
            const response = await epos2Axios.get('/api/slots/'
                + slotBarcode + "/serviceticket?log_completion=true&serviceticket_id=" + ticketId);

            return {
                status: response.data.status,
                slot: response.data.data.slot || null,
                message: response.data.message,
                isValidServiceTicket: response.data.data.valid_serviceticket,
                isComplete: response.data.data.is_complete,
            };
        } catch (error) {
            console.error(`Error: ${error.response.status}`);

            if (error.response.status === 404) {
                return {
                    status: error.response.status,
                    slot: null,
                    message: 'The slot was not found',
                    isComplete: false,
                };
            }
            return {
                status: error.response.status,
                slot: null,
                message: 'An error occurred while fetching the slot for the ticket',
            };
        }
    }

    async clearSlot(slotBarcode) {
        try {
            const response = await epos2Axios.delete('/api/slots/'
                + slotBarcode + "/serviceticket");
            console.log(response.status);

            return {
                status: response.data.status,
                message: response.data.message,
            };
        } catch (error) {
            console.error(`Error: ${error.response.status}`);

            return {
                status: error.response.status,
                message: 'An error occurred while trying to clear the slot for rail ' + slotBarcode + ': '
                    + error.response.data.message,
            };
        }
    }
}

export default new PiecingUpService();